import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=e542dffc&scoped=true&"
import script from "./Gift.vue?vue&type=script&lang=ts&"
export * from "./Gift.vue?vue&type=script&lang=ts&"
import style0 from "./Gift.vue?vue&type=style&index=0&id=e542dffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e542dffc",
  null
  
)

export default component.exports